import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { Company, CompanyDirectorship } from '../../../core/models';
import { ModalService } from '../../../core/services/modal.service';
import { MatSort, MatSortable, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UserSubscription } from '../../../modules/auth';
import { methodology } from '../../../core/constants/methodology';

@Component({
  selector: 'app-director-stat-list',
  templateUrl: './director-stat-list.component.html',
  styleUrls: ['./director-stat-list.component.scss'],
})
export class DirectorStatListComponent implements AfterViewInit {
  @Input() directorships?: CompanyDirectorship[];
  @Input() company: Company;
  @Input() subscription: UserSubscription | null;
  displayedColumns: string[] = [
    'name',
    'age',
    'gender',
    'influence',
    'overall',
    'ebitda',
    'carbon_intensity',
    'tsr',
    'controversies',
  ];

  resultsLength = 0;
  dataSource: MatTableDataSource<CompanyDirectorship>;
  constructor(private readonly modalService: ModalService) {}
  @ViewChild(MatSort) sort: MatSort;

  ngAfterViewInit() {
    this.dataSource = new MatTableDataSource(this.directorships);
    this.sort.sort({ id: 'influence', start: 'desc' } as MatSortable);
    this.sort.disableClear = true;
    this.dataSource.sort = this.sort;
  }

  sortData(sort: Sort) {
    if (!this.directorships) return;
    const data = this.directorships.slice();
    this.dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'age':
          return compare(a.director.age, b.director.age, isAsc);
        case 'influence':
          return compare(a.influence, b.influence, isAsc);
        case 'overall':
          return compare(a.overall, b.overall, isAsc);
        case 'ebitda':
          return compare(a.ebitda, b.ebitda, isAsc);
        case 'carbon_intensity':
          return compare(a.carbon_intensity, b.carbon_intensity, isAsc);
        case 'tsr':
          return compare(a.tsr, b.tsr, isAsc);
        case 'controversies':
          return compare(a.controversies, b.controversies, isAsc);
        default:
          return 0;
      }
    });
  }

  openDirectorProfile(directorship: CompanyDirectorship) {
    const _directorship: CompanyDirectorship = {
      ...directorship,
      company: this.company,
    };
    this.modalService.openDirectorProfile(_directorship);
  }

  protected readonly methodology = methodology;
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
